// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5f737af9","545":"6dcb296d"}[chunkId] + ".chunk.js";
};